// @flow
import React, { Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../common/GlobalContext";

import ArrowDropDown from "elevate-ui-icons/ArrowDropDown";

type $Props = {
  classes: Object,
  idx: number,
  item: Object,
  onToggleDropdown: Function,
};

const RenderLink = ({ classes, item, idx, onToggleDropdown }: $Props) => {
  const { children, shortLabel, label, href, isNewTab } = item;
  const hasChildren = children && children.length;
  return (
    <a
      key={idx}
      href={href || "#"}
      className={item.class || ""}
      onClick={(e) =>
        hasChildren ? onToggleDropdown(e, idx.toString()) : null
      }
      target={isNewTab ? "_blank" : ""}
      rel={isNewTab ? "noopener nofollow" : ""}
    >
      {shortLabel ? (
        <Fragment>
          <div className={classes.mobileOnly}>
            {label}
            {hasChildren ? <ArrowDropDown /> : null}
          </div>
          <div className={classes.visibleBlock}>
            {shortLabel}
            {hasChildren ? <ArrowDropDown /> : null}
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <span>{label}</span>
          {hasChildren ? <ArrowDropDown /> : null}
        </Fragment>
      )}
    </a>
  );
};

const styles = (theme) => ({
  mobileOnly: {
    [theme.breakpoints(900)]: {
      display: "none",
    },
  },
  visibleBlock: {
    display: "none",
    [theme.breakpoints(900)]: {
      display: "block",
    },
  },
});

export default withGlobalContext(withStyles(styles)(RenderLink));
